import { Close } from "assets/icons/Common";
import { Col, HorizontalLine, IconButton } from "components/primitives";
import { ReactNode } from "react";
import styled from "styled-components";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  header: ReactNode;
}

export const RightSideBar = ({ isOpen, onClose, children, header }: Props) => {
  return (
    <SettingsSidebar aria-expanded={isOpen}>
      <CloseButton Icon={Close} onClick={onClose} />
      <InnerContainer>
        <SettingsHeader>{header}</SettingsHeader>

        <SettingsContainer>
          <HorizontalLine margin="0.5em 0em" />

          {children}
        </SettingsContainer>
      </InnerContainer>
    </SettingsSidebar>
  );
};

const SettingsSidebar = styled.div`
  --sidebar-width: 20rem;
  position: fixed;
  height: 100dvh;
  width: var(--sidebar-width);
  z-index: 6000;
  right: calc(var(--sidebar-width) * -1 - 50px);
  top: 0;
  container-type: size;
  container-name: settings-bar;
  background-color: white;
  box-shadow: 0 0 3px 0;
  transition: right 300ms ease;
  border-left: thin solid black;

  &[aria-expanded="true"] {
    right: 0;
  }
`;

const InnerContainer = styled(Col).attrs({ className: "px-3" })`
  align-items: center;
  height: 100%;
`;

const SettingsHeaderHeight = "4rem";

const SettingsHeader = styled.div.attrs({ className: "p-2" })`
  width: 100%;
  height: ${SettingsHeaderHeight};
  display: flex;
  flex-direction: row;
  color: var(--secondary);
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

const SettingsContainer = styled(Col)`
  height: calc(100% - ${SettingsHeaderHeight});
  overflow-y: auto;
  width: 100%;
  padding: 0 8px;
`;

const CloseButton = styled(IconButton)`
  position: absolute;
  left: 0;
  top: 15px;
  width: 32px;
  transform: translate(-50%, 0);
  padding: 8px;
`;
